<p-dialog header="{{'cart_added_to_cart' | translate}}" [style]="{width: _width}" [(visible)]="displayAddedToCart" [modal]="true" [baseZIndex]="10000">
    <div *ngIf="note">
        <div class="note_cart">{{'cart_single_note' | translate}} <span class="note">{{note.title}}</span> {{'cart_added' | translate}}</div>
        
        <!-- <div class="cart_description"><span class="note_description">{{'cart_table_header_price' | translate}}: <span class="price">{{note.price | currencyReduce | currency: selectedCurrency}}</span></span></div>-->

        <div class="p-justify-between p-grid cart_footer">
            <div>
                <button (click)="displayAddedToCart = false" pButton type="button" label="{{'cart_continue_shopping' | translate}}" class="ui-button-raised ui-button-info"></button>
            </div>
            <div>
                <button pButton (click)="goToCart()" type="button" label="{{'cat_go_to_cart_and_make_payment' | translate}}" class="ui-button-raised ui-button-success"></button>
            </div>
        </div>
    </div>
</p-dialog>


<p-dialog [style]="{width: _width}" header="{{'cart_error' | translate}}" [(visible)]="visibleErrorCart" [modal]="true" [baseZIndex]="10000">
    <div *ngIf="note">
        <div class="note_cart">{{'cart_single_note' | translate}} <span class="note">{{note.title}}</span> {{'cart_not_added' | translate}}</div>
        <div class="cart_description"><span class="note_description">{{'cart_note_exists_in_cart' | translate}}</span></div>
            <div class="p-justify-between p-grid cart_footer">
                <div>
                    <button (click)="visibleErrorCart = false" pButton type="button" label="{{'cart_continue_shopping' | translate}}" class="ui-button-raised ui-button-info"></button>
                </div>
                <div>
                    <button pButton type="button" label="{{'cat_go_to_cart_and_make_payment' | translate}}" class="ui-button-raised ui-button-success"></button>
                </div>
            </div>
        </div>
</p-dialog>